import { render, staticRenderFns } from "./DocumentsView.vue?vue&type=template&id=e5eea48a&scoped=true&"
import script from "./DocumentsView.vue?vue&type=script&lang=js&"
export * from "./DocumentsView.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsView.vue?vue&type=style&index=0&id=e5eea48a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5eea48a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VAlert,VContainer,VPagination})
